
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/ios",
      function () {
        return require("private-next-pages/en/legal/ios.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/legal/ios"])
      });
    }
  